import React from 'react'
import MainLayoutTemplate from '../../templates/MainLayout/MainLayoutTemplate'

const MainLayout = () => {
  return (
   <MainLayoutTemplate/>
  )
}

export default MainLayout